import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import workinprogress from '../../Assets/workinprogress.png';
import Particle from "../Particle";

function Project() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container >
        <Row className="align-items-center justify-content-center text-center project-row">
          {/* Left Column: Image */}
          <Col md={6} className="d-flex justify-content-center">
            <img src={workinprogress} alt="Project Preview" className="project-image mb-5" />
          </Col>

          {/* Right Column: Work in Progress */}
          <Col md={6} className="d-flex justify-content-center align-items-center">
            <h2 className="work-text text-white">🚀 Work in Progress...</h2>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Project;
